export const projects = [
  {
    title: "Tennis Events",
    subtitle: "Google API & Nightmare.js",
    description: "Subscribe to a unified calendar of ATP and WTA tournaments.",
    image: "./project-1.gif",
    link: "https://tennis-events.herokuapp.com",
  },
  {
    title: "Chaa-ching",
    subtitle: "MERN Stack & Plaid API",
    description: "Link your accounts, track transactions, and set budgets in one dashboard.",
    image: "./project-2.gif",
    link: "https://www.chaa-ching.app",
  },
  {
    title: "Live Chat",
    subtitle: "React & AWS Amplify",
    description: "A real-time chat progressive web app.",
    image: "./project-3.gif",
    link: "https://main.d2hg3fs4j3hz86.amplifyapp.com",
  },
  {
    title: "To-Do List",
    subtitle: "React Hooks",
    description: "Add, toggle, and remove tasks with ease.",
    image: "./project-4.gif",
    link: "https://reacthooks-to-do-list.netlify.app/",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Redux",
  "Node.js",
  "Express",
  "MongoDB",
  "PostgreSQL",
  "Google APIs",
  "Material UI",
  "Tailwind CSS",
  "Bootstrap",
  "Nightmare.js",
];



// WEBPACK FOOTER //
// ./src/data.js